// The New Task modal's fields at rest - see Store.js's `newTaskDraft` and
// components/Project/NewTicket.js, which resets to this (give or take an
// auto-picked ticket type - see its own clearDraft) whenever the dialog is
// actually dismissed (the X button, or a successful Save) rather than just
// hidden behind a click on its backdrop.
export const DEFAULT_NEW_TASK_DRAFT = {
    name: "",
    body: "",
    points: 0,
    ticketTemplateId: "",
    sprintId: "",
    scopeId: "",
    priority: 1,
    assignedToId: null,
    fieldValues: {},
};
